import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SidebarContent } from './VivictaSidebar';

export const navModule = createFrontendModule({
  pluginId: 'app',
  extensions: [SidebarContent],
});
